import React, { useState } from 'react';
import { NewsletterApi } from '../app/api/newsletter.api';


export function Footer ()
{

  const newsletter = NewsletterApi();

  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState('');


  const handleSubmit = async () => {

    setStatus(0);
    setIsLoading(true);

    try {
        const {data} = await newsletter.insert({email: email});
        if( data.success ){
          setStatus(1);
          setMessage( data.message );
        }
        else{
          setMessage("Une erreur est survenue. Veuillez réessayer")
          setStatus(-1);
        }
    } catch (err) { 
        setStatus(-1);   
        const response = err?.response?.data;
      
        if (response?.message) {
          setMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setMessage(response.errors[0].msg || response.errors[0]);
        } else {
          setMessage("Une erreur est survenue. Veuillez réessayer.");
        }
    } finally{
        setIsLoading(false);  
    }
  }

  return (
    <footer className="footer-section pt-5">
      <div className="container text-center">
        {/* Logo & Description */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="footer-logo mb-3">
              <span className="logo-box px-4"> ORTEGA </span>
            </div>
            <p className="footer-desc mx-auto">
              ORTÉGA accompagne les entreprises, les structures de santé ainsi que les particuliers dans la fourniture, l’installation et la maintenance d’équipements biomédicaux, informatiques et de mobilier, ainsi que dans le développement de solutions logicielles performantes et durables.
            </p>
          </div>
        </div>

        {/* Social Icons */}
        <div className="social-icons mb-5">
          <a href="https://www.facebook.com/61588918603527"><i className="bi bi-facebook"></i></a>
          <a href="https://x.com/OrtegaContact"><i className="bi bi-twitter-x"></i></a>
          <a href="https://www.linkedin.com/company/ortega-hub"><i className="bi bi-linkedin"></i></a>
          <a href="https://www.instagram.com/ortegacontact"><i className="bi bi-instagram"></i></a>
          <a href="/"><i className="bi bi-music-note"></i></a>
        </div>

        {/* Main Footer Links */}
        <div className="footer-content border-top border-secondary pt-5 pb-4">
          <div className="row text-start">
            
            {/* Contact Us */}
            <div className="col-md-3 mb-4">
              <h5 className="footer-title">CONTACTEZ NOUS</h5>
              <ul className="list-unstyled contact-list">
                <li><i className="bi bi-house-door"></i> Dakar, Sénégal </li>
                {/* <li><i className="bi bi-telephone"></i> (+221) 33 000 00 00 </li> */}
                <li><i className="bi bi-telephone"></i> ( +221 ) 78 826 42 42 </li>
                <li><i className="bi bi-envelope"></i> <a href="mailto:contact@ortega-hub.com" style={{ textDecoration: 'none' }}> contact@ortega-hub.com </a> </li>
                <li><i className="bi bi-clock"></i> Lundi - Vendredi : 8h - 18h <br/> <span className="ms-4"> Samedi: 9h - 17h </span></li>
              </ul>
            </div>

            {/* Information */}
            <div className="col-md-3 mb-4">
              <h5 className="footer-title">INFORMATION</h5>
              <ul className="list-unstyled">
                <li><a href="/produits">Produits</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/apropos">Apropos </a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>

            {/* Quick Links */}
            <div className="col-md-3 mb-4">
              <h5 className="footer-title">LIENS RAPIDES</h5>
              <ul className="list-unstyled">
                <li><a href="/">Accueil</a></li>
                <li><a href="/commandes-en-cours">Commandes</a></li>
                <li><a href="/condition-utilisation">Condition d'utilisation</a></li>
              </ul>
            </div>

            {/* Newsletter */}
            <div className="col-md-3 mb-4">
              <h5 className="footer-title">NEWSLETTER</h5>
              <p className="newsletter-text">Abonnez-vous à notre newsletter pour recevoir nos nouveautés directement dans votre boîte mail.</p>
              <div className="newsletter-form">
                {
                  isLoading && (
                    <div className="d-flex justify-content-center mb-3"> 
                      <div className="spinner-border text-white" role="status" aria-label="Chargement"></div>
                    </div>
                  )
                }
                {
                  status === 1 && (
                    <div className="alert alert-success rounded-0 small mb-3 w-100 py-1"> 
                      <i className="bi bi-check-circle"></i> { message } 
                    </div>
                  )
                }
                {
                  status === -1 && (
                    <div className="alert alert-danger rounded-0 small mb-3 w-100 py-1"> 
                      <i className="bi bi-x-circle"></i> { message } 
                    </div>
                  )
                }
                <input type="email" placeholder="Votre address email" className="form-control bg-light text-dark mb-2 px-3" value={email} onChange={(e) => setEmail(e.target.value)} required />
                <button type='submit' className="btn btn-green px-4 py-2 rounded-0 w-100" onClick={ handleSubmit }> 
                  S'ABONNER <i className="bi bi-chevron-right ms-2"></i> 
                </button>
              </div>
              {/* <div className="payment-icons mt-3">
                <i className="bi bi-credit-card-2-front me-2"></i>
                <i className="bi bi-paypal me-2"></i>
                <i className="bi bi-stripe"></i>
              </div> */}
            </div>

          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom py-3">
        <div className="container text-center">
          <p className="m-0">
            <span className="text-green fw-bold"> ORTEGA SITEWEB </span> © 2025 Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

